import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'common-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})
export class ToggleComponent implements OnInit, ControlValueAccessor {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() checked: boolean = false;
  @Input() ariaLabel: string = '';
  @Input() customClass: string = '';

  @Output() change = new EventEmitter<boolean>();
  @Output() toggleChange = new EventEmitter<boolean>();

  private _onChange: (value: boolean) => void = () => { };
  private _onTouched: () => void = () => { };

  constructor() { }

  ngOnInit(): void { }

  // ControlValueAccessor implementation
  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Event handlers
  onToggleChange(event: any): void {
    const checked = event.checked;
    this.checked = checked;
    this._onChange(checked);
    this._onTouched();
    this.change.emit(checked);
    this.toggleChange.emit(checked);
  }
}
